export default __webpack_public_path__ + "static/media/data.f771c99f.svg";